// extracted by mini-css-extract-plugin
module.exports = {"icon":"index_icon_3xGpN","carousel":"index_carousel_-Pj6C"};